import React, { useState, useEffect } from 'react';
import '../styles/WhatsAppButton.css';

const WhatsAppButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Mostrar o botão após 2 segundos
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Mostrar tooltip após 5 segundos se o usuário não interagiu
    const tooltipTimer = setTimeout(() => {
      setShowTooltip(true);
    }, 5000);

    return () => clearTimeout(tooltipTimer);
  }, []);

  const handleClick = () => {
    const message = encodeURIComponent(
      'Olá! Gostaria de saber mais informações sobre os serviços da Clínica CIS.'
    );
    const whatsappUrl = `https://wa.me/5569992246189?text=${message}`;
    window.open(whatsappUrl, '_blank');
    
    // Esconder tooltip após clique
    setShowTooltip(false);
  };

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  if (!isVisible) return null;

  return (
    <div className="whatsapp-container">
      <button
        className="whatsapp-button"
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        aria-label="Falar no WhatsApp"
        title="Falar no WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
        
        {showTooltip && (
          <div className="whatsapp-tooltip">
            <span>Fale conosco!</span>
            <div className="tooltip-arrow"></div>
          </div>
        )}
      </button>
      
      <div className="whatsapp-pulse"></div>
    </div>
  );
};

export default WhatsAppButton;

